<template>
  <div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col>
          <card>
            <b-row align-v="center" slot="header">
              <b-col cols="8">
                <h3 class="mb-0" v-if="!idEdit">Realize seu cadastro</h3>
                <h3 class="mb-0" v-else>Cadastro de Profissional</h3>
              </b-col>
              <b-col cols="4" v-loading="loading" />
            </b-row>

            <b-form @submit.prevent="save" v-loading="loading">
              <!-- Dados de Acesso -->
              <h6 class="heading-small text-muted mb-4">Dados de Acesso</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="email"
                      label="E-mail de Acesso"
                      name="E-mail de Acesso"
                      placeholder="exemplo@email.com"
                      v-model="user.emailAcesso"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="password"
                      label="Senha"
                      name="Senha"
                      placeholder="Digite sua senha"
                      v-model="user.senha"
                      :disabled="idEdit"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Responsável pela inscrição -->
              <h6 class="heading-small text-muted mb-4">
                Responsável pela inscrição
              </h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome"
                      name="Nome"
                      placeholder="Digite seu nome"
                      v-model="user.nomeResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="email"
                      label="E-mail"
                      name="E-mail"
                      placeholder="exemplo@email.com"
                      v-model="user.emailResponsavel"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Celular"
                      name="Celular"
                      placeholder="(00) 0000-0000"
                      v-model="user.celularResponsavel"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </div>

              <hr class="my-4" />
              <!-- Dados de Acesso -->
              <h6 class="heading-small text-muted mb-4">
                Indicações por categoria
              </h6>
              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Criação</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoCriacao"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaCriacao"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoCriacao"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Atendimento</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoAtendimento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaAtendimento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoAtendimento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Planejamento</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoPlanejamento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaPlanejamento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoPlanejamento"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Mídia</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoMidia"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaMidia"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoMidia"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Marketing Anunciante</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoAnunciante"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaAnunciante"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoAnunciante"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Comunicação em
                  Veículos</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoVeiculo"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaVeiculo"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoVeiculo"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Imprensa / Relações
                  Públicas</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoImprensa"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaImprensa"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoImprensa"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <b-card class="mb-4">
                <b-card-title class="d-flex justify-content-between"
                  >Categoria Profissional de Marketing Digital</b-card-title
                >
                <b-row>
                  <b-col lg="5">
                    <base-input
                      type="text"
                      label="Nome do Profissional indicado"
                      name="Nome do Profissional indicado"
                      placeholder="Digite o nome do profissional indicado"
                      v-model="user.nomeProfissionalIndicadoMarketingDigital"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="4">
                    <base-input
                      type="text"
                      label="Empresa/agência que trabalha"
                      name="Empresa/agência que trabalha"
                      placeholder="Digite o nome da empresa ou agência"
                      v-model="user.empresaMarketingDigital"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="3">
                    <base-input
                      type="text"
                      label="Cargo"
                      name="Cargo"
                      placeholder="Digite o cargo"
                      v-model="user.cargoMarketingDigital"
                      inputGroupWrapperClasses="m-0"
                    >
                    </base-input>
                  </b-col>
                </b-row>
              </b-card>

              <hr class="my-4" />
              <div
                class="pl-lg-4 d-flex justify-content-end align-items-center"
              >
                <span class="text-danger mr-3">{{ errorFeedback }}</span>
                <base-button
                  type="primary"
                  native-type="submit"
                  :loading="loading"
                  class="my-4"
                >
                  <span v-if="!idEdit">Cadastrar</span>
                  <span v-else>Salvar</span>
                </base-button>
              </div>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "profissional-form",
  data() {
    return {
      errorFeedback: "",
      loading: false,
      idEdit: null,
      user: {
        id: "",
        cargoAnunciante: "",
        cargoAtendimento: "",
        cargoCriacao: "",
        cargoImprensa: "",
        cargoMarketingDigital: "",
        cargoMidia: "",
        cargoPlanejamento: "",
        cargoVeiculo: "",
        celularResponsavel: "",
        emailAcesso: "",
        emailResponsavel: "",
        empresaAnunciante: "",
        empresaAtendimento: "",
        empresaCriacao: "",
        empresaImprensa: "",
        empresaMarketingDigital: "",
        empresaMidia: "",
        empresaPlanejamento: "",
        empresaVeiculo: "",
        nomeProfissionalIndicadoAnunciante: "",
        nomeProfissionalIndicadoAtendimento: "",
        nomeProfissionalIndicadoCriacao: "",
        nomeProfissionalIndicadoImprensa: "",
        nomeProfissionalIndicadoMarketingDigital: "",
        nomeProfissionalIndicadoMidia: "",
        nomeProfissionalIndicadoPlanejamento: "",
        nomeProfissionalIndicadoVeiculo: "",
        nomeResponsavel: "",
        senha: "",
      },
    };
  },
  methods: {
    async save() {
      this.errorFeedback = "";
      this.loading = true;
      try {
        await api.post("/profissional", this.user);
        this.$router.push("/cadastro/profissional/fim");
      } catch (e) {
        this.throwError();
      } finally {
        this.loading = false;
      }
    },
    throwError(msg) {
      this.errorFeedback =
        msg || "Ocorreu um problema. Por favor, tente novamente mais tarde.";
    },
  },
  async mounted() {
    this.idEdit = this.$route.params.id;
    if (this.idEdit) {
      this.loading = true;
      try {
        const response = await api.get(`/profissional/${this.idEdit}`);
        this.user = response.data;
      } catch (e) {
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao carregar os dados. Por favor, tente novamente mais tarde."
        );
      } finally {
        this.loading = false;
      }
    } else if (this.$route.params.email) {
      this.user.emailAcesso = this.$route.params.email;
      this.user.senha = this.$route.params.password;
    }
  },
};
</script>
<style></style>
